"use client";

import AnimatedCounter from "@/lib/CountUpClient";
import InfoTooltip from "@/lib/ToolTipClient";

export default function ClientStatsBlock() {
    return (
        <div className="bg-oxford/50 p-6 rounded-lg border border-ivory/10 mb-8">
            <div className="flex flex-col md:flex-row gap-4 justify-between relative">
                <div className="absolute top-16 left-0 w-full h-0.5 bg-ivory/10"></div>

                <div className="text-center">
                    <div className="text-6xl font-heading text-gray-200 mb-3 min-h-[80px] relative">
                        <AnimatedCounter end={98} suffix="%" duration={2} />
                        <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-mid-white rounded-full border-2 border-oxford"></div>
                    </div>
                    <p className="text-ivory/70 text-sm flex items-center justify-center gap-1 mt-4">
                        Children enrolled in primary school
                        <InfoTooltip content="Source: World Bank Data" />
                    </p>
                </div>

                <div className="text-center">
                    <div className="text-6xl font-heading text-jellyfish mb-3 min-h-[80px] relative">
                        <AnimatedCounter end={33} suffix="%" duration={2} delay={0.4} />
                        <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-jellyfish rounded-full border-2 border-oxford"></div>
                    </div>
                    <p className="text-ivory/70 text-sm flex items-center justify-center gap-1 mt-4">
                        Pursue higher education
                        <InfoTooltip content="Source: India Skill Report" />
                    </p>
                </div>

                <div className="text-center">
                    <div className="text-6xl font-heading text-dark-peach mb-3 min-h-[80px] relative">
                        <AnimatedCounter end={18} suffix="%" duration={2} delay={0.8} />
                        <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-dark-peach rounded-full border-2 border-oxford"></div>
                    </div>
                    <p className="text-ivory/70 text-sm flex items-center justify-center gap-1 mt-4">
                        Secure meaningful employment
                        <InfoTooltip content="Source: India Skill Report" />
                    </p>
                </div>
            </div>
        </div>
    );
}